'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SignupFlows = require('./constants/SignupFlows');

var _AllowedIntents = require('./constants/AllowedIntents');

var _AllowedIntents2 = _interopRequireDefault(_AllowedIntents);

var _AllowedUtms = require('./constants/AllowedUtms');

var _AllowedUtms2 = _interopRequireDefault(_AllowedUtms);

var _AllowedHubs = require('./constants/AllowedHubs');

var _AllowedHubs2 = _interopRequireDefault(_AllowedHubs);

var _IntentsToPath = require('./constants/IntentsToPath');

var _IntentsToPath2 = _interopRequireDefault(_IntentsToPath);

var _UtmsToPath = require('./constants/UtmsToPath');

var _UtmsToPath2 = _interopRequireDefault(_UtmsToPath);

var _HubsToPath = require('./constants/HubsToPath');

var _HubsToPath2 = _interopRequireDefault(_HubsToPath);

var _AllowedCustomOpts = require('./constants/AllowedCustomOpts');

var _AllowedCustomOpts2 = _interopRequireDefault(_AllowedCustomOpts);

var _OptsToPath = require('./constants/OptsToPath');

var _OptsToPath2 = _interopRequireDefault(_OptsToPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SIGNUP_ROOT_PATH = '/signup';
var DEFAULT_SIGNUP_PATHNAME = SIGNUP_ROOT_PATH + '/crm';
var HUBS_PREFIX = 'HUBS_';
var UTM_PREFIX = 'UTM_';

var buildQueryParams = function buildQueryParams(query) {
  var queries = [];
  var orderedKeys = Object.keys(query).sort();
  orderedKeys.forEach(function (queryKey) {
    if (query.hasOwnProperty(queryKey)) {
      var queryValue = query[queryKey];
      if (queryValue) {
        // should we ever push empty param & values?
        queries.push(encodeURIComponent(queryKey) + '=' + encodeURIComponent(queryValue));
      }
    }
  });

  return queries.length ? '?' + queries.join('&') : '';
};

var getPathFromFlow = function getPathFromFlow(signupFlow) {
  if (_SignupFlows.SignupFlows.hasOwnProperty(signupFlow) && _SignupFlows.SignupFlowToPath.hasOwnProperty(signupFlow)) {
    return _SignupFlows.SignupFlowToPath[signupFlow];
  }

  console.error('Couldn`t find signup flow, defaulting to crm');
  return _SignupFlows.SignupFlowToPath[_SignupFlows.SignupFlows.CRM];
};

var getIntentPathFromIntent = function getIntentPathFromIntent(intentParam) {
  if (_AllowedIntents2.default.hasOwnProperty(intentParam) && _IntentsToPath2.default.hasOwnProperty(intentParam)) {
    return _IntentsToPath2.default[intentParam];
  }

  console.error('Couldn`t find intent for ' + intentParam + ', leaving empty');
  return null;
};

function getAllowedParam(param) {
  var allowedParam = _AllowedCustomOpts2.default;
  var paramToPath = _OptsToPath2.default;

  if (param.indexOf(HUBS_PREFIX) === 0) {
    allowedParam = _AllowedHubs2.default;
    paramToPath = _HubsToPath2.default;
  }

  if (param.indexOf(UTM_PREFIX) === 0) {
    allowedParam = _AllowedUtms2.default;
    paramToPath = _UtmsToPath2.default;
  }

  return { allowedParam: allowedParam, paramToPath: paramToPath };
}

var getParamPathFromParam = function getParamPathFromParam(param) {
  var _getAllowedParam = getAllowedParam(param),
      allowedParam = _getAllowedParam.allowedParam,
      paramToPath = _getAllowedParam.paramToPath;

  if (allowedParam.hasOwnProperty(param) && paramToPath.hasOwnProperty(param)) {
    return paramToPath[param];
  }

  console.error('Couldn`t find mapping for ' + param + ', leaving empty');
  return null;
};

var SignupUrlGenerator = function () {
  function SignupUrlGenerator(signupFlow) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SignupUrlGenerator);

    this.shouldUpdateOptions = true;
    this.signupFlow = signupFlow;
    this.options = options || {};
    if (!this.options.query) {
      this.options.query = {};
    }

    try {
      var signupRoute = getPathFromFlow(this.signupFlow);
      this.signupPathname = SIGNUP_ROOT_PATH + '/' + signupRoute;
      this.signupQueryParams = this.updateOptions(options);
    } catch (error) {
      this.signupPathname = DEFAULT_SIGNUP_PATHNAME;
      this.signupQueryParams = '';
    }
  }

  _createClass(SignupUrlGenerator, [{
    key: 'updateOptions',
    value: function updateOptions(options) {
      var updated = options.query ? buildQueryParams(options.query) : '';
      this.shouldUpdateOptions = false;
      return updated;
    }
  }, {
    key: 'getPathname',
    value: function getPathname() {
      return this.signupPathname;
    }
  }, {
    key: 'getSearch',
    value: function getSearch() {
      return this.shouldUpdateOptions ? this.updateOptions(this.options) : this.signupQueryParams;
    }
  }, {
    key: 'getUrl',
    value: function getUrl() {
      return '' + this.signupPathname + this.getSearch();
    }
  }, {
    key: 'withIntent',
    value: function withIntent(intent) {
      var value = getIntentPathFromIntent(intent);
      if (value) {
        this.options.query.intent = value;
        this.shouldUpdateOptions = true;
      }
      return this;
    }
  }, {
    key: 'withParam',
    value: function withParam(param, paramValue) {
      var key = getParamPathFromParam(param);
      if (key) {
        this.options.query[key] = paramValue || _OptsToPath.OptsToValue[param];
        this.shouldUpdateOptions = true;
      }
      return this;
    }
  }, {
    key: 'withUtm',
    value: function withUtm(utm, utmValue) {
      return this.withParam(utm, utmValue);
    }
  }, {
    key: 'withHubs',
    value: function withHubs(hubs, hubsValue) {
      return this.withParam(hubs, hubsValue);
    }
  }, {
    key: 'withOption',
    value: function withOption(option) {
      return this.withParam(option);
    }
  }]);

  return SignupUrlGenerator;
}();

exports.default = SignupUrlGenerator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/SignupUrlGenerator.js
// module id = 425
// module chunks = 0